import styled from 'styled-components'

export const ResultCountRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 1.25rem 0 1rem;
  font-family: Rubik, verdana, sans-serif;
  font-size: 0.875rem;
  color: ${({ theme }) => theme.grey700Color};
`

// Groups the result-count text with an optional inline action (the
// enter-selection control) so they sit together on the left, with the sort
// control kept on the right via ResultCountRow's space-between.
export const CountGroup = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 0.75rem;
`

export const SortDropdown = styled.div`
  position: relative;
`

export const SortTrigger = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.25rem 0.5rem;
  border: none;
  background: transparent;
  font-family: Rubik, verdana, sans-serif;
  font-size: 0.75rem;
  font-weight: 500;
  letter-spacing: 0.0625rem;
  color: ${({ theme }) => theme.grey900Color};
  cursor: pointer;
  border-radius: 0.25rem;

  &:hover {
    background: ${({ theme }) => theme.grey200Color};
  }

  &:focus-visible {
    outline: 0.125rem solid ${({ theme }) => theme.primaryColor};
    outline-offset: 0.125rem;
  }
`

export const SortDropdownMenu = styled.ul`
  position: absolute;
  top: calc(100% + 0.5rem);
  right: 0;
  min-width: 14rem;
  margin: 0;
  padding: 0.5rem 0;
  list-style: none;
  background: ${({ theme }) => theme.whiteColor};
  border: 0.0625rem solid ${({ theme }) => theme.grey300Color};
  border-radius: 0.25rem;
  box-shadow: 0 0.25rem 0.625rem 0 rgb(0 0 0 / 8%);
  z-index: 10;
`

export const SortDropdownItem = styled.li`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.625rem 1rem;
  font-family: Rubik, verdana, sans-serif;
  font-size: 0.875rem;
  color: ${({ theme }) => theme.grey900Color};
  cursor: pointer;

  &:hover {
    background: ${({ theme }) => theme.grey100Color};
  }
`

export const SortCheck = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`
